export const DEFAULT_LAYOUT_SIZE = '25%';

export const DEFAULT_LAYOUT = {
  type: 'default',
  font_size_offset: 0,
  alignment_x: 1,
  alignment_y: 1,
  size: DEFAULT_LAYOUT_SIZE,
} as const;
